<hlm-toaster />

<div class="flex min-h-screen flex-col justify-between bg-sakoo-bg py-12 px-6 sm:px-8">
  <div class="my-auto flex flex-col items-center">
    <!-- Contenedor del Logo de Sakoo -->
    <div class="mb-8 flex flex-col items-center">
      <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-white shadow-md border border-sakoo-border">
        <!-- Icono representativo de Sakoo -->
        <img src="img/sakoo_icon.png" alt="Sakoo" draggable="false"
          class="h-10 w-10 object-contain animate-bounce select-none" />
      </div>
      <h2 class="mt-4 text-3xl font-extrabold tracking-tight text-slate-800">
        Sakoo <span class="text-sakoo-green">BO</span>
      </h2>
      <p class="mt-2 text-sm text-sakoo-dark font-medium">
        Panel de Control Administrativo
      </p>
    </div>

    <!-- Tarjeta del Formulario -->
    <div class="w-full max-w-md overflow-hidden rounded-2xl border border-sakoo-border bg-white p-8 shadow-xl">
      <div class="mb-6">
        <h3 class="text-xl font-bold text-slate-800">Iniciar Sesión</h3>
        <p class="text-xs text-sakoo-dark mt-1">
          Ingresa tus datos para acceder a la plataforma.
        </p>
      </div>

      <form (submit)="onSubmit(); $event.preventDefault()" class="space-y-5">
        <!-- Campo: Correo Electrónico -->
        <div class="space-y-1.5">
          <label hlmLabel for="email" class="text-slate-700 font-semibold">
            Correo Electrónico
          </label>
          <div class="relative flex items-center">
            <svg lucideMail class="absolute left-3 h-4 w-4 text-sakoo-dark"></svg>
            <input id="email" type="email" placeholder="admin@sakoo.com" [formField]="loginForm.email" hlmInput
              class="pl-9 h-10 border-sakoo-border focus-visible:border-sakoo-green focus-visible:ring-sakoo-green/20" />
          </div>
          <!-- Mensaje de Error -->
          @if (loginForm.email().touched() && loginForm.email().errors().length) {
          <div class="flex items-center gap-1 text-xs text-rose-500 mt-1">
            <svg lucideAlertCircle class="h-3.5 w-3.5"></svg>
            <span>{{ loginForm.email().errors()[0].message }}</span>
          </div>
          }
        </div>

        <!-- Campo: Contraseña -->
        <div class="space-y-1.5">
          <div class="flex items-center justify-between">
            <label hlmLabel for="password" class="text-slate-700 font-semibold">
              Contraseña
            </label>
            <!-- <a href="javascript:void(0)" class="text-xs font-semibold text-sakoo-dark hover:text-sakoo-green transition-colors">
              ¿Olvidaste tu contraseña?
            </a> -->
          </div>
          <div class="relative flex items-center">
            <svg lucideLock class="absolute left-3 h-4 w-4 text-sakoo-dark"></svg>
            <input id="password" [type]="showPassword() ? 'text' : 'password'" placeholder="••••••••"
              [formField]="loginForm.password" hlmInput
              class="pl-9 pr-10 h-10 border-sakoo-border focus-visible:border-sakoo-green focus-visible:ring-sakoo-green/20" />
            <!-- Botón mostrar/ocultar contraseña -->
            <button type="button" (click)="togglePasswordVisibility()"
              class="absolute right-3 flex h-6 w-6 items-center justify-center rounded-md text-sakoo-dark hover:text-sakoo-green transition-colors focus:outline-none">
              @if (showPassword()) {
              <svg lucideEyeOff class="h-4 w-4"></svg>
              } @else {
              <svg lucideEye class="h-4 w-4"></svg>
              }
            </button>
          </div>
          <!-- Mensaje de Error -->
          @if (loginForm.password().touched() && loginForm.password().errors().length) {
          <div class="flex items-center gap-1 text-xs text-rose-500 mt-1">
            <svg lucideAlertCircle class="h-3.5 w-3.5"></svg>
            <span>{{ loginForm.password().errors()[0].message }}</span>
          </div>
          }
        </div>

        <!-- Checkbox: Mantener sesión iniciada -->
        <!-- <div class="flex items-center justify-between pt-1">
          <div class="flex items-center gap-2">
            <input id="rememberMe" type="checkbox" [formField]="loginForm.rememberMe"
              class="h-4.5 w-4.5 rounded border-sakoo-border text-sakoo-green focus:ring-sakoo-green focus:ring-offset-0" />
            <label for="rememberMe" class="text-xs font-medium text-slate-700 select-none cursor-pointer">
              Recordar mi cuenta
            </label>
          </div>
        </div> -->

        <!-- Botón de Entrada -->
        <button hlmBtn type="submit"
          class="w-full h-10 text-sm font-bold bg-sakoo-green text-slate-800 hover:bg-sakoo-green/90 border-transparent transition-all shadow-md active:translate-y-px disabled:opacity-70 disabled:cursor-not-allowed"
          [disabled]="loginForm().invalid() || loginForm().pending() || isLoading()">
          @if (isLoading()) {
          <hlm-spinner class="mr-2 text-base" />
          <span>Iniciando sesión...</span>
          } @else {
          <span>Iniciar Sesión</span>
          }
        </button>
      </form>
    </div>
  </div>

  <!-- Footer -->
  <div class="text-center text-xs text-sakoo-dark font-medium">
    © 2026 Sakoo. Todos los derechos reservados.
  </div>
</div>